import React, { useRef } from 'react';
import { Modal, Box, Grid, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DIALOG_BOX_STYLE } from '../../_constants/styleConst';
import { I18nMessage } from '../../types/type';

type ConfirmModalProps = {
  isOpen: boolean;
  displayMessage: string | I18nMessage;
  onClickCancel?: () => void;
  onClickOk: () => void | Promise<void>;
  cancelLabel?: string;
  okLabel?: string;
};

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  displayMessage,
  onClickCancel,
  onClickOk,
  cancelLabel = 'BTN_CANCEL',
  okLabel = 'BTN_OK',
}) => {
  const { t } = useTranslation();
  const formatMessage = (inputValue: string | I18nMessage): string => {
    if (typeof inputValue === 'string') {
      return inputValue.toString();
    }
    return t(inputValue.messageKey, inputValue.values);
  };
  const isProcessing = useRef(false);

  // OKボタン押下時
  const handleClickOk = async () => {
    if (isProcessing.current) {
      // 連打防止
      return;
    }
    isProcessing.current = true;
    try {
      await onClickOk();
    } finally {
      isProcessing.current = false;
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClickCancel}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={DIALOG_BOX_STYLE}>
        <Typography
          id="modal-title"
          variant="h6"
          component="h2"
          sx={{ whiteSpace: 'pre-line' }}
        >
          {formatMessage(displayMessage)}
        </Typography>
        <Typography id="modal-body" variant="h6" component="h3">
          <Grid container spacing={2}>
            <Grid size={12}></Grid>
            <Grid size={6}>
              <Button onClick={onClickCancel} variant="outlined" fullWidth>
                {t(cancelLabel)}
              </Button>
            </Grid>
            <Grid size={6}>
              <Button
                onClick={handleClickOk}
                variant="contained"
                fullWidth
                disabled={isProcessing.current}
              >
                {t(okLabel)}
              </Button>
            </Grid>
          </Grid>
        </Typography>
      </Box>
    </Modal>
  );
};

export default ConfirmModal;
